// La fecha de fin de un permiso dado aparte · AC-10 (1 oct 2026).
//
// Funciones puras, sin React, para que la regla se pruebe sola.
//
// EL «HOY» LO DA EL SERVIDOR, no `new Date()`. Un permiso se decide
// caducado con el día de la base (`GET /api/permisos/caducan-pronto`
// devuelve `hoy`), y de noche el teléfono y el servidor pueden estar en
// días distintos: con el reloj del teléfono el campo dejaría elegir un día
// que el servidor rechaza, o rechazaría uno que el servidor acepta. Si el
// «hoy» no llegó (sin red, sin permiso), no se valida aquí: el servidor
// sigue diciendo que no a una fecha pasada, con su mensaje.

const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio',
  'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

// «2026-10-15» → «15 de octubre de 2026». Sin `Date`: una fecha sin hora
// pasada por `new Date()` se lee en UTC y en México sale el día anterior.
export function fechaDelDia(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
  if (!m) return String(iso || '');
  return `${Number(m[3])} de ${MESES[Number(m[2]) - 1]} de ${m[1]}`;
}

// Días de `desde` a `hasta`, las dos «AAAA-MM-DD». Con `Date.UTC` las dos
// quedan en el mismo huso y la resta no se mueve con el horario de verano.
export function diasEntre(desde, hasta) {
  const a = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(desde || ''));
  const b = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(hasta || ''));
  if (!a || !b) return null;
  const ua = Date.UTC(+a[1], +a[2] - 1, +a[3]);
  const ub = Date.UTC(+b[1], +b[2] - 1, +b[3]);
  return Math.round((ub - ua) / 86400000);
}

// El error del campo, o null si la fecha sirve. Vacía sirve: es «no caduca».
export function errorDeFechaFin(hasta, hoy) {
  if (!hasta) return null;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(hasta)) return 'Escribe la fecha completa: día, mes y año.';
  if (hoy && diasEntre(hoy, hasta) < 0) {
    return `Esa fecha ya pasó. Elige del ${fechaDelDia(hoy)} en adelante, o deja el campo vacío.`;
  }
  return null;
}

// Lo que va a pasar, dicho antes de pulsar.
export function textoDeVigencia(hasta, hoy, personas = 1) {
  const quienes = personas === 1 ? 'esta persona' : `las ${personas} personas`;
  if (!hasta) {
    return `Sin fecha de fin: ${quienes} ${personas === 1 ? 'lo conserva' : 'lo conservan'} hasta que alguien lo quite.`;
  }
  const d = hoy ? diasEntre(hoy, hasta) : null;
  const cuando = d === 0 ? ' (hoy)' : d === 1 ? ' (mañana)' : d > 1 ? ` (en ${d} días)` : '';
  return `Deja de valer al terminar el ${fechaDelDia(hasta)}${cuando}, para ${quienes}.`;
}

// «en 3 días», «mañana», «hoy»: para la lista de los que caducan pronto.
export function cuandoCaduca(diasRestantes) {
  const d = Number(diasRestantes);
  if (d <= 0) return 'hoy es su último día';
  if (d === 1) return 'mañana es su último día';
  return `le quedan ${d} días`;
}
